export default __webpack_public_path__ + "static/media/morocco.f194bcf2.png";